<template>
    <v-app id="token" class="yoprimary" style="background-color: #00a650">
    </v-app>
</template>
<script>
export default {
  name: "Token",

  created() {
    let token = this.$route.query.access_token;
    this.$store.dispatch("auth/token", { token, vm: this });
  }
};
</script>
